<template>
  <div class="alert-trend-chart">
    <!-- Toggle Controls -->
    <div class="chart-filters" style="margin-bottom: 15px; display: flex; gap: 15px; align-items: center;">
      <span style="font-weight: 600; color: #323232;">Show:</span>
      <label class="filter-toggle" v-for="(dataset, index) in allDatasets" :key="index">
        <input 
          type="checkbox" 
          :checked="visibleLines[index]" 
          @change="toggleLine(index)"
          style="margin-right: 8px;"
        />
        <span :style="{ color: dataset.borderColor, fontWeight: '500' }">
          {{ dataset.label }}
        </span>
      </label>
    </div>
    
    <div class="alert-trend-section__chart" style="margin-bottom: 30px">
      <LineChart :chartData="filteredChartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import LineChart from '@shared/components/LineChart';

export default {
  name: 'AlertTrendChart',
  components: {
    LineChart,
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 20
          }
        }
      })
    }
  },
  data() {
    return {
      visibleLines: []
    };
  },
  computed: {
    allDatasets() {
      return this.chartData.datasets || [];
    },
    filteredChartData() {
      const filteredDatasets = this.allDatasets.filter((dataset, index) => this.visibleLines[index]);
      return {
        ...this.chartData,
        datasets: filteredDatasets
      };
    }
  },
  watch: {
    chartData: {
      handler(newData) {
        // Initialize visibility state when chart data changes
        if (newData && newData.datasets) {
          this.visibleLines = new Array(newData.datasets.length).fill(true);
        }
      },
      immediate: true
    }
  },
  methods: {
    toggleLine(index) {
      this.$set(this.visibleLines, index, !this.visibleLines[index]);
    }
  }
};
</script>

<style lang="scss" scoped>
.alert-trend-chart {
  width: 100%;
}

.chart-filters {
  .filter-toggle {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    
    &:hover {
      opacity: 0.8;
    }
    
    input[type="checkbox"] {
      cursor: pointer;
    }
  }
}
</style> 